import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation unarchiveOrganization($id: String!) {
    unarchiveOrganization(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const unarchiveOrganizationRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/unarchive_organization',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.unarchiveOrganization;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const unarchiveOrganizationSlice = createSlice({
  name: 'unarchive_organization',
  initialState: initialState,
  reducers: {
    unarchiveOrganizationClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(unarchiveOrganizationRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(unarchiveOrganizationRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(unarchiveOrganizationRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { unarchiveOrganizationClear } =
unarchiveOrganizationSlice.actions;

export const unarchiveOrganization = createSelector(
  (state: RootState) => state.organization.unarchiveOrganization.result,
  (state: RootState) => state.organization.unarchiveOrganization.error,
  (state: RootState) => state.organization.unarchiveOrganization.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default unarchiveOrganizationSlice.reducer;